import React, { createContext, useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { PATH_MAP } from "../configuration/PathMap"
import { PlanUsageStatus } from "../Objects/Company/PlanUsageStatus"

interface UpgradePlanContextType {
  isOpenPlan: boolean
  planUsageStatus?: PlanUsageStatus
  closePlan: () => void
  openPlan: (planUsageStatus?: PlanUsageStatus) => void
}

const UpgradePlanContext = createContext<UpgradePlanContextType | undefined>(undefined)

export const UpgradePlanProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpenPlan, setIsOpen] = useState(false)

  const [planUsageStatus, setPlanUsageStatus] = useState<PlanUsageStatus | undefined>(undefined)

  const navigate = useNavigate()

  const openPlan = (planUsageStatus?: PlanUsageStatus) => {
    setPlanUsageStatus(planUsageStatus)

    setIsOpen(false)

    navigate(PATH_MAP.PLANS_PAGE)
  }
  const closePlan = () => setIsOpen(false)

  return (
    <UpgradePlanContext.Provider value={{ isOpenPlan, openPlan, closePlan, planUsageStatus }}>
      {children}
    </UpgradePlanContext.Provider>
  )
}

export const useUpgradePlan = () => {
  const context = useContext(UpgradePlanContext)

  if (!context) {
    throw new Error("useUpgradePlan must be used inside UpgradePlanProvider")
  }

  return context
}
